module.exports = __webpack_public_path__ + "img/page-8.ee2ea4e6.png";